export enum ParticipantCategoryNames {
    None = 0,
    NoneDescription = 'participantCategoryNone',
    OverallExcludeSelf = 1,
    OverallExcludeSelfDescription = 'participantCategoryOverallExcludeSelf',
    JuniorColleagues = 2,
    JuniorColleaguesDescription = 'participantCategoryJuniorColleagues',
    Peers = 3,
    PeersDescription = 'participantCategoryPeers',
    SeniorColleagues = 4,
    SeniorColleaguesDescription = 'participantCategorySeniorColleagues',
    Subordinates = 5,
    SubordinatesDescription = 'participantCategorySubordinates',
    Other = 6,
    OtherDescription = 'participantCategoryOther',
    Self = 7,
    SelfDescription = 'participantCategorySelf',
    ComparisonGroup = 8,
    ComparisonGroupDescription = 'participantCategoryComparisonGroup',
    Overall = 9,
    OverallDescription = 'participantCategoryOverall'
}
